<template>
  <v-card flat>
    <v-card-title>
      Exchanges History
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        text="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="columns"
      :items="allExchanges"
      :search="search"
      :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
    >
      <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{formated_date_time(props.item.updated_at)}}</td>
        <td>{{props.item.currency}}</td>
        <td>{{props.item.buy_amount}}</td>
        <td>{{props.item.sell_amount}}</td>
        <td>{{props.item.user}}</td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      columns: [
        {
          text: 'Date',
          value: 'created_at'
        },
        {
          text: 'Currency',
          value: 'currency'
        },
        {
          text: 'Buying value',
          value: 'buy_amount'
        },
        {
          text: 'Selling value',
          value: 'sell_amount'
        },
        {
          text: 'Updated By',
          value: 'user'
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_all_exchanges')
  }
}
</script>

<style>

</style>
